/* tslint:disable */
/* eslint-disable */
/**
 * DIV.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Photos } from './Photos';
import {
    PhotosFromJSON,
    PhotosFromJSONTyped,
    PhotosToJSON,
    PhotosToJSONTyped,
} from './Photos';
import type { TimeZone } from './TimeZone';
import {
    TimeZoneFromJSON,
    TimeZoneFromJSONTyped,
    TimeZoneToJSON,
    TimeZoneToJSONTyped,
} from './TimeZone';
import type { DisplayName } from './DisplayName';
import {
    DisplayNameFromJSON,
    DisplayNameFromJSONTyped,
    DisplayNameToJSON,
    DisplayNameToJSONTyped,
} from './DisplayName';
import type { Viewport } from './Viewport';
import {
    ViewportFromJSON,
    ViewportFromJSONTyped,
    ViewportToJSON,
    ViewportToJSONTyped,
} from './Viewport';
import type { GoogleMapsLinks } from './GoogleMapsLinks';
import {
    GoogleMapsLinksFromJSON,
    GoogleMapsLinksFromJSONTyped,
    GoogleMapsLinksToJSON,
    GoogleMapsLinksToJSONTyped,
} from './GoogleMapsLinks';
import type { AddressComponents } from './AddressComponents';
import {
    AddressComponentsFromJSON,
    AddressComponentsFromJSONTyped,
    AddressComponentsToJSON,
    AddressComponentsToJSONTyped,
} from './AddressComponents';
import type { Location } from './Location';
import {
    LocationFromJSON,
    LocationFromJSONTyped,
    LocationToJSON,
    LocationToJSONTyped,
} from './Location';

/**
 * 
 * @export
 * @interface PlaceDetails
 */
export interface PlaceDetails {
    /**
     * 
     * @type {string}
     * @memberof PlaceDetails
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PlaceDetails
     */
    id?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof PlaceDetails
     */
    types?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof PlaceDetails
     */
    formattedAddress?: string | null;
    /**
     * 
     * @type {Array<AddressComponents>}
     * @memberof PlaceDetails
     */
    addressComponents?: Array<AddressComponents> | null;
    /**
     * 
     * @type {Location}
     * @memberof PlaceDetails
     */
    location?: Location;
    /**
     * 
     * @type {Viewport}
     * @memberof PlaceDetails
     */
    viewport?: Viewport;
    /**
     * 
     * @type {string}
     * @memberof PlaceDetails
     */
    googleMapsUri?: string | null;
    /**
     * 
     * @type {number}
     * @memberof PlaceDetails
     */
    utcOffsetMinutes?: number | null;
    /**
     * 
     * @type {string}
     * @memberof PlaceDetails
     */
    adrFormatAddress?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PlaceDetails
     */
    iconMaskBaseUri?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PlaceDetails
     */
    iconBackgroundColor?: string | null;
    /**
     * 
     * @type {DisplayName}
     * @memberof PlaceDetails
     */
    displayName?: DisplayName;
    /**
     * 
     * @type {string}
     * @memberof PlaceDetails
     */
    shortFormattedAddress?: string | null;
    /**
     * 
     * @type {Array<Photos>}
     * @memberof PlaceDetails
     */
    photos?: Array<Photos> | null;
    /**
     * 
     * @type {boolean}
     * @memberof PlaceDetails
     */
    pureServiceAreaBusiness?: boolean | null;
    /**
     * 
     * @type {GoogleMapsLinks}
     * @memberof PlaceDetails
     */
    googleMapsLinks?: GoogleMapsLinks;
    /**
     * 
     * @type {TimeZone}
     * @memberof PlaceDetails
     */
    timeZone?: TimeZone;
}

/**
 * Check if a given object implements the PlaceDetails interface.
 */
export function instanceOfPlaceDetails(value: object): value is PlaceDetails {
    return true;
}

export function PlaceDetailsFromJSON(json: any): PlaceDetails {
    return PlaceDetailsFromJSONTyped(json, false);
}

export function PlaceDetailsFromJSONTyped(json: any, ignoreDiscriminator: boolean): PlaceDetails {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
        'id': json['id'] == null ? undefined : json['id'],
        'types': json['types'] == null ? undefined : json['types'],
        'formattedAddress': json['formattedAddress'] == null ? undefined : json['formattedAddress'],
        'addressComponents': json['addressComponents'] == null ? undefined : ((json['addressComponents'] as Array<any>).map(AddressComponentsFromJSON)),
        'location': json['location'] == null ? undefined : LocationFromJSON(json['location']),
        'viewport': json['viewport'] == null ? undefined : ViewportFromJSON(json['viewport']),
        'googleMapsUri': json['googleMapsUri'] == null ? undefined : json['googleMapsUri'],
        'utcOffsetMinutes': json['utcOffsetMinutes'] == null ? undefined : json['utcOffsetMinutes'],
        'adrFormatAddress': json['adrFormatAddress'] == null ? undefined : json['adrFormatAddress'],
        'iconMaskBaseUri': json['iconMaskBaseUri'] == null ? undefined : json['iconMaskBaseUri'],
        'iconBackgroundColor': json['iconBackgroundColor'] == null ? undefined : json['iconBackgroundColor'],
        'displayName': json['displayName'] == null ? undefined : DisplayNameFromJSON(json['displayName']),
        'shortFormattedAddress': json['shortFormattedAddress'] == null ? undefined : json['shortFormattedAddress'],
        'photos': json['photos'] == null ? undefined : ((json['photos'] as Array<any>).map(PhotosFromJSON)),
        'pureServiceAreaBusiness': json['pureServiceAreaBusiness'] == null ? undefined : json['pureServiceAreaBusiness'],
        'googleMapsLinks': json['googleMapsLinks'] == null ? undefined : GoogleMapsLinksFromJSON(json['googleMapsLinks']),
        'timeZone': json['timeZone'] == null ? undefined : TimeZoneFromJSON(json['timeZone']),
    };
}

export function PlaceDetailsToJSON(json: any): PlaceDetails {
    return PlaceDetailsToJSONTyped(json, false);
}

export function PlaceDetailsToJSONTyped(value?: PlaceDetails | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'id': value['id'],
        'types': value['types'],
        'formattedAddress': value['formattedAddress'],
        'addressComponents': value['addressComponents'] == null ? undefined : ((value['addressComponents'] as Array<any>).map(AddressComponentsToJSON)),
        'location': LocationToJSON(value['location']),
        'viewport': ViewportToJSON(value['viewport']),
        'googleMapsUri': value['googleMapsUri'],
        'utcOffsetMinutes': value['utcOffsetMinutes'],
        'adrFormatAddress': value['adrFormatAddress'],
        'iconMaskBaseUri': value['iconMaskBaseUri'],
        'iconBackgroundColor': value['iconBackgroundColor'],
        'displayName': DisplayNameToJSON(value['displayName']),
        'shortFormattedAddress': value['shortFormattedAddress'],
        'photos': value['photos'] == null ? undefined : ((value['photos'] as Array<any>).map(PhotosToJSON)),
        'pureServiceAreaBusiness': value['pureServiceAreaBusiness'],
        'googleMapsLinks': GoogleMapsLinksToJSON(value['googleMapsLinks']),
        'timeZone': TimeZoneToJSON(value['timeZone']),
    };
}

